import { useContext } from 'react';

import { TimeseriesChartSeriesCurve } from '../context/TimeseriesChartSeriesCurve.context.js';

export const useSeriesCurve = () => useContext(TimeseriesChartSeriesCurve);
